<template>
<div>
    <div class="divButtonRigth" style="margin-bottom: 20px" >
      <el-select
      class="tenant-select"
      @change="_getInfoSetListPage()"
      v-show="this.role.tenantId=='sys'? true:false"
      v-model="listQuery.tenantId"
      >
        <el-option
        v-for="item in tenantList"
        :key="item.tenantId"
        :label="item.name"
        :value="item.tenantId"
        >
        </el-option>
      </el-select>

      <el-button type="success" size="small" @click="changeStatus('1')">启用</el-button>
      <el-button type="danger" size="small" @click="changeStatus('0')">禁用</el-button>
      <el-button v-show="this.role.tenantId=='sys'" type="primary" size="small" @click="showAddDailog">新增</el-button>
      <el-button type="primary" size="small" @click="initCacheInfo">初始化到缓存</el-button>
      <el-button type="primary" size="small" @click="exportTableData">导出</el-button>
    </div>
    <bsp-table
      :data="list"
      ref="infoDataTable"
      show-header-overflow
      show-overflow
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      :ciic-data-filter.sync="listQuery"
      @ciic-data-refresh="_getinfoSetListPage"
      @select-change="selectChange"
    >
      <vxe-table-column type="selection" width="60" fixed="left" align="center" ></vxe-table-column>
      <vxe-table-column title="序号" type="index" width="60" fixed="left" align="center"></vxe-table-column>
      <bsp-table-column
        field="infoSetId"
        title="表名"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.infoSetId }}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column
        field="infoSetName"
        title="中文名称"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.infoSetName }}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column
        field="infoSetEnName"
        title="英文名称"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.infoSetEnName }}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column
        field="infoSetType"
        set-id="1032"
        title="类型"
        filter-type="select"
        multiple="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.infoSetType | dictFilter(dicts)}}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column
        field="infoSetRstype"
        title="记录类型"
        filter-type="select"
        :options-type="infoSetRsTypeList"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.infoSetRstype | dictListFilter(infoSetRsTypeList)}}</span>
        </template>
      </bsp-table-column>

      <!--<bsp-table-column
        field="infoSetSeq"
        title="排序顺序"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.infoSetSeq }}</span>
        </template>
      </bsp-table-column>-->

      <!--<bsp-table-column
        field="infoSetOrder"
        title="排序字段"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.infoSetOrder }}</span>
        </template>
      </bsp-table-column>-->

      <!--<bsp-table-column
        field="infoItemGroup"
        title="分组中文"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.infoItemGroup }}</span>
        </template>
      </bsp-table-column>-->

      <!--<bsp-table-column
        field="infoItemEnGroup"
        title="分组英文"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.infoItemEnGroup }}</span>
        </template>
      </bsp-table-column>-->

      <!--<bsp-table-column
        field="linkClass"
        title="联动更新类"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.linkClass }}</span>
        </template>
      </bsp-table-column>-->

      <bsp-table-column
        field="infoSetStatus"
        title="状态"
        filter-type="input"
        :options-type="status"
      >
        <template slot-scope="scope">
          <!-- <el-switch
           style="display: block"
           v-model="scope.row.infoSetStatus"
           active-color="#13ce66"
           inactive-color="#ff4949"
           active-text="启用"
           active-value="1"
           inactive-value="0"
           @change="changeStatus(scope.row)"
          >
          </el-switch> -->
          <span>{{ scope.row.infoSetStatus | dictListFilter(status)}}</span>
        </template>

      </bsp-table-column>

      <bsp-table-column
        field="tenantId"
        title="租户"
        filter-type="input"
        :options-type="status"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.tenantId}}</span>
        </template>

      </bsp-table-column>

      <bsp-table-column
        title="操作"
      >
        <template slot-scope="scope">
          <div class="ciic-table-operate">
            <el-button size="small" type="text" @click="goToCodeItemPage(scope.row)">
              <i class="el-icon-search el-icon--right"></i>查看信息项
            </el-button>
            <el-button size="small" type="text" @click="showUpdateDialog(scope.row)">
              <i class="el-icon-edit el-icon--right"></i>编辑
            </el-button>
          </div>
        </template>
      </bsp-table-column>
    </bsp-table>
    <sys-info-set-dialog
     ref="dialogForm"
     :dialog-status="dialogStatus"
     :dialog-form-visible.sync="dialogFormVisible"
     :list-form="listForm"
     :dicts="this.dicts"
     :info-set-rstype-list="infoSetRsTypeList"
     @data-refresh="_getInfoSetListPage"
    >
    </sys-info-set-dialog>
</div>
</template>

<script>
import BspTable from "@/components/bsp/bsp-table/bsp-table";
import BspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
import SysInfoSetDialog from "./SysInfoSetDialog"
import exportMethod from "@/util/export"
import { getListpage,initInfo,changeSysInfoSetStatus } from "@/api/sys/info";
import {mapGetters} from 'vuex';
export default {
    name: 'SysInfoSet',
    components: {
        BspTable,
        BspTableColumn,
        SysInfoSetDialog
    },

    created() {
      this._getInfoSetListPage();
      this.getTenantList();
    },

    data() {
      return {
        // 当前页面使用角色
        role:{
            name: 'admin',
            tenantId: 'sys'
        },
        loading: false,
        tenantList:[],
        list: [],
        dialogFormVisible: false,
        dialogStatus: 'add',
        listForm: {},

        listQuery: {
          limit: 20,
          page: 1,
          total: 0,
          tenantId: 'sys'
        },
        multipleSelection:[],

        infoSetRsTypeList:[{
          codeItemId: '1',
          codeItemName: '单记录'
        },
        {
          codeItemId: '2',
          codeItemName: '多记录'
        }],
        status:[
            {codeItemName:'禁用',codeItemId:'0'},
            {codeItemName:'启用',codeItemId:'1'}
        ]
      }
    },

    computed: {
      ...mapGetters([
        'dicts',
      ]),
    },

    methods: {
      // 跳转到代码项页面
      goToCodeItemPage(row){
          console.log('传递的代码集ID为：'+row.infoSetId+'租户Id为：'+row.tenantId)
          this.$router.push({
              path: '/sys/infoItem',
              query:{
                  infoSetId: row.infoSetId,
                  tenantId: row.tenantId
              }
          })
      },
      _getInfoSetListPage() {
        this.loading=true
        this.dialogFormVisible = false;
        getListpage(this.listQuery).then(res => {
          console.log(res);
          this.listQuery.total = res.data.total;
          this.list = res.data.records;
          this.loading=false
        })
      },
      // 新增
      showAddDailog() {
        this.listForm = {};
        this.dialogFormVisible = true;
        this.dialogStatus = 'add';
      },
      showUpdateDialog(row) {
        this.listForm = row;
        this.dialogFormVisible = true;
        this.dialogStatus = 'update';
      },

      //批量更改状态
      selectChange({checked, row}){
        if(checked){
          this.multipleSelection.push(row)
        }
        if(!checked){
            this.multipleSelection.filter((item,index) => {
              if(item===row){
                  this.multipleSelection.splice(index,1)
              }
            })
        }
      },
      exportTableData () {
        let obj = {
              columns:this.$refs['infoDataTable'].tableColums,
              ...this.listQuery,
              type: 'excel',
              fileName: '信息集表格数据.xls',
              beanName: 'sysParameterServiceImpl',
              methodName: 'queryListPageVO',
              headerRowNum: 2
        };
        exportMethod(obj);
      },
      changeStatus(status){
          let listSize=this.multipleSelection.length
        if(listSize==0){
            this.$message.error('请选择至少选中一行')
        }else{
          let param={
            multipleSelection: this.multipleSelection,
            status: status
          }
          changeSysInfoSetStatus(param).then(res =>{
            if(res.data.code==0){
              this.$message.success(res.data.msg)
            }else{
              this.$message.error(res.data.msg)
            }
          })
        }
      },
      getTenantList(){
        let tmp=[
            {
                name: 'admin',
                tenantId: 'sys'
            },
            {
                name: '中智财务',
                tenantId: "2"
            }
        ]
        tmp.forEach(value=>{
            this.tenantList.push(value)
        })
      },
      initCacheInfo(){
        initInfo().then(res=>{
          this.$message.success("初始化成功");
        });
      }
    }
}
</script>

<style lang="scss">
.tenant-select {
  width: 100px;
  margin: 0px 10px;
}
</style>
